import type { FC } from 'react';

import type { DragImageProps } from '../../draggable_items/draggable_items';
import SearchItemsThumbnail from '../search_items_thumbnail/search_items_thumbnail';
import SearchDragImage from './search_items_drag_image';

import styles from './search_items_drag_image.module.css';

const SearchListDragImage: FC<DragImageProps> = (props) => {
  const { items = [] } = props;
  const [item] = items;
  return item ? (
    <SearchDragImage {...props}>
      <div className={styles.list_item_box}>
        <SearchItemsThumbnail value={item.keyframes ?? undefined} item={item} />
        <div className={styles.list_item_box_title}>{item.title}</div>
        {items.length > 1 ? (
          <div className={styles.list_item_box_count}>+{items.length - 1}</div>
        ) : null}
      </div>
    </SearchDragImage>
  ) : null;
};

export default SearchListDragImage;
